<template>
<div>
    <div class="panel panel-default">
        <div class="panel-heading">
            View Details
        </div>
        <div class="panel-body">
            <form class="form-horizontal" role="form" @submit.prevent="updateView">
                <div class="form-group">
                    <label class="col-md-4 control-label">Property</label>

                    <div class="col-md-6">
                        <p class="form-control-static" v-text="view.property_id"></p>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label">View Name</label>

                    <div class="col-md-6">
                        <p class="form-control-static" v-text="view.view_name"></p>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label">View Label</label>

                    <div class="col-md-6">
                        <input type="text" class="form-control" name="url" v-model="view.view_label">
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-offset-4 col-md-6">
                        <button type="submit" class="btn btn-primary" :class="{'btn-loading': loading}" :disabled="loading">Update</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    </div>
</div>
</template>

<script>
import {
	mapGetters
} from 'vuex';

export default {
	data() {
		return {
            loading: false,
		}
	},

	computed: {
		...mapGetters('client', {
			'client': 'activeClient',
			'isAdmin': 'isAdmin',
			'view': 'activeView',
		}),
	},

	methods: {
        updateView() {
			let view = this.view;
			this.loading = true;
			this.$store.dispatch('client/updateGaView', {
                view: view
            })
            .then((response) => {
                this.loading = false;
                Bus.$emit('show-success-alert', response.message);
            })
            .catch((error) => {
                console.log(error);
            })
		}
	}
}
</script>

<style scoped lang="scss">
table.table.ga-views {
    tbody > tr > td {
        vertical-align: middle;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/GaViewDetails.vue